import { getDefaultPreconfiguration } from "@lib/getDefaultPreconfiguration";
import { usePreconfigurationsSelector } from "@redux/reducers/appConfig";

export const useDefaultPreconfiguration = () => {
  const preconfigurations = usePreconfigurationsSelector();

  return getDefaultPreconfiguration(preconfigurations);
};
